import React, { useState } from "react";

import { SupplierAwaitingDeliveryStyle } from "./SupplierAwaitingDeliveryStyle";
// use hooks
import { useNotDelivererOrderOnline } from "../../hooks/useAccounting";

// components
import { Table } from "../../components/Table/Table";
import Button from "../../components/Button/Button";

// styled components
import { Container } from "../../theme/GlobalStyle";
import Loading from "../../components/Loadings/LoadingTable";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
const SupplierAwaitingDelivery = () => {
  const [PageNumber, setPageNumber] = useState(1);

  const headerTitle = [
    "نام و نام خانوادگی",
    "شماره تماس",
    "کد پیگیری",
    "تاریخ و ساعت",
    "مبلغ کل",
    "مبلغ پرداخت شده",
    "عملیات",
  ];

  const { data, isLoading } = useNotDelivererOrderOnline(PageNumber);

  const allToDelivererOrderOnline = data?.data?.ToDelivererOrderOnline;
  const count = data?.data?.ToDelivererNumber;
  // handle next page
  const handleNext = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  // handle previos page
  const handlePrevios = () => {
    if (PageNumber === 1) {
      setPageNumber(1);
    } else {
      setPageNumber((prevState) => prevState - 1);
    }
  };

  const items = allToDelivererOrderOnline?.map((item) => (
    <tr key={item.IdOrderOnline}>
      <td>
        <div className="d-flex align-items-center">
          <div className="symbol symbol-45px ">
            <img src="" alt="" />
          </div>
          <div className="d-flex justify-content-start flex-column">
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.FirstName + " " + item.LastName}
            </span>
          </div>
        </div>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {item.Phone}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {item.IdShowUserOrderOnline}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {MiladiToShamsi(item.created_at)}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {item.PriceAll}
        </span>
      </td>
      <td>
        <span className="text-muted fw-bold text-muted d-block fs-7">
          {item.DepositAll}
        </span>
      </td>
      <td>
        <Button size="12px" bgColor="#0D6EFD" small="100px" color="#fff">
          جزییات
        </Button>
      </td>
    </tr>
  ));

  if (isLoading) {
    return <Loading />;
  }

  return (
    <SupplierAwaitingDeliveryStyle className="mt-3">
      <Table
        title={`لیست سفارشات در انتظار تحویل پیک (${count})`}
        headerTitle={headerTitle}
        items={items}
        handleNext={handleNext}
        handlePrevios={handlePrevios}
        PageNumber={PageNumber}
        paginate={items?.length > 0 ? true : false}
      />
    </SupplierAwaitingDeliveryStyle>
  );
};

export default SupplierAwaitingDelivery;
